import { render } from "./PostEditorAddPhotoArea.vue?vue&type=template&id=298c69e8&scoped=true"
import script from "./PostEditorAddPhotoArea.vue?vue&type=script&lang=ts"
export * from "./PostEditorAddPhotoArea.vue?vue&type=script&lang=ts"

import "./PostEditorAddPhotoArea.vue?vue&type=style&index=0&id=298c69e8&lang=scss&scoped=true"
import "./PostEditorAddPhotoArea.vue?vue&type=style&index=1&id=298c69e8&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-298c69e8"

export default script